/* globals window document */
// Home-specific js

import Vue from "vue";
import $ from "jquery";
import Slick from "slick-carousel";
import moment from "moment";
import locale from "locale";

import newItemsTemplate from "./templates/news-items.html";

//Date formatting settings for moment.js
import calendarFormats from "./calendar-formats.json";
//Labels for the carousel images
import carouselImageLabels from "./carousel-image-labels.json"

var apiURL = "/api/fb_feed";

//onload
$(() => {
  setupCarousel();
  setupNews();
});

function setupCarousel() {
  initializeSlick();
  setupCarouselIndicators();
  setupPlayPauseButton();
  setupImageLabels();
}

function initializeSlick() {
  //if site is in rtl mode
  if ($("html").attr("dir") == "rtl") {
    setupSlickObject();

    $(".c-carousel__images").slick("slickSetOption", "rtl", true, true);

    //add the rtl images
    var i;
    for (i = 1; i < 6; i++) {
      $(".c-carousel__images").slick("slickAdd",'<div class="c-carousel__image c-carousel__image--image'+i+'-rtl"></div>');
    }
  }

  //if site is in ltr mode
  else {
    setupSlickObject();

    //add the ltr images
    var j;
    for (j = 1; j < 6; j++) {
      $(".c-carousel__images").slick("slickAdd",'<div class="c-carousel__image c-carousel__image--image'+j+'"></div>');
    }
  }
}

function setupSlickObject() {
  $(".c-carousel__images").slick({
    accessibility: true,
    dots: true,
    appendDots: $(".c-carousel__indicators-container"),
    dotsClass: "u-custom-slick-dots",
    arrows: false,
    autoplay: true,
    autoplaySpeed: 7000,
    fade: true,
    cssEase: "ease-in-out",
    speed: 1000,
    swipe: true
  });

  //remove previous images
  $(".c-carousel__images").slick("removeSlide", null, null, true);
}

function setupCarouselIndicators() {
  $(".u-custom-slick-dots").find("li").addClass("i-carousel-indicator"); //add the indicator icons
  $(".u-custom-slick-dots").find("li").addClass("c-carousel__indicator"); //add the indicator class

  $(".c-carousel__indicator").find("button").addClass("c-carousel__indicator-button");
  $(".c-carousel__indicator").find("button").addClass("u-focus-white-outline");

  $(".u-custom-slick-dots").children().eq(0).removeClass("i-carousel-indicator");
  $(".u-custom-slick-dots").children().eq(0).addClass("i-carousel-indicator-selected");

  //set up the selected indicator
  $(".c-carousel__images").on("beforeChange", function(event, slick, currentSlide, nextSlide){
    var currentSlideObj = $(".u-custom-slick-dots").children().eq(currentSlide);
    var nextSlideObj = $(".u-custom-slick-dots").children().eq(nextSlide);

    currentSlideObj.removeClass("i-carousel-indicator-selected");
    currentSlideObj.addClass("i-carousel-indicator");

    nextSlideObj.removeClass("i-carousel-indicator");
    nextSlideObj.addClass("i-carousel-indicator-selected");
  });
}

function setupPlayPauseButton() {
  $(".c-carousel__play-pause-button").click(function() {
    if($(".c-carousel__play-pause-button").hasClass("i-pause")) {
      $(".c-carousel__images").slick("slickPause");
      $(".c-carousel__play-pause-button").removeClass("i-pause");
      $(".c-carousel__play-pause-button").addClass("i-play");
    }
    else {
      $(".c-carousel__images").slick("slickPlay");
      $(".c-carousel__play-pause-button").removeClass("i-play");
      $(".c-carousel__play-pause-button").addClass("i-pause");
    }
  });
}

function setupImageLabels() {
  var labels = [];

  switch (locale) {
    case "en_US":
      labels = carouselImageLabels.english;
    break;
    case "he_IL":
      labels = carouselImageLabels.hebrew;
    break;
    case "de_DE":
      labels = carouselImageLabels.german;
    break;
    case "ru_RU":
      labels = carouselImageLabels.russian;
    break;
    case "ar_EG":
      labels = carouselImageLabels.arabic;
    break;
  }

  var carouselImages = $(".c-carousel__image");

  for (var i = 0; i < carouselImages.length; i++) {
    $(carouselImages[i]).attr("aria-label", labels[i]);
    $(carouselImages[i]).attr("aria-label", labels[i]);
  }
}

function setupNews() {
  new Vue({
    el: "#news-items",

    data: {
      items: []
    },

    template: newItemsTemplate,

    created: function () {
     this.fetchNewsData();
    },

    updated: function () {
      truncateNews();
    },

    methods: {
      fetchNewsData: function () {
        var dateRaw;
        var self = this;

        $.get(apiURL, function(data) {
          self.items = data;
          var arrayLength = self.items.length;

          for (var i=0; i<arrayLength; i++) {
            dateRaw = self.items[i].date;
            self.items[i].date = localizeDate(dateRaw);
          }
        });
      }
    }
  });
}

function localizeDate(dateRaw) {
  var myMoment = moment(dateRaw);
  myMoment.locale(locale);

  switch(locale) {
    case "en_US":
      return myMoment.calendar(null, calendarFormats.english);
    case "he_IL":
      return myMoment.calendar(null, calendarFormats.hebrew);
    case "de_DE":
      return myMoment.calendar(null, calendarFormats.german);
    case "ar_EG":
      return myMoment.calendar(null, calendarFormats.arabic);
    case "ru_RU":
      return myMoment.format("DD.MM.YYYY");
    default:
  }
}

function truncateNews() {
  $(".c-hp-news-item__text")
  .dotdotdot({
    height: "watch",
    keep: ".c-hp-news-item__read-more",
    watch: true
  });
}





// WEBPACK FOOTER //
// ./src/frontend/pages/home/home.js